"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(allDeployments, deploymentIds, surveyHandles) {
  if (surveyHandles === 'all') {
    return [];
  }
  var result = allDeployments.filter(function (item) {
    if (deploymentIds !== 'all' && !deploymentIds.includes(item.deploymentId)) {
      return false;
    }
    return !item.settings.options.some(function (handle) {
      return surveyHandles.includes(handle);
    });
  }).map(function (item) {
    return item.deploymentId;
  });
  return result;
};